/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditScheduleAuditSchedulesGetQueryResponse, AuditScheduleAuditSchedulesGetPathParams } from "../models/AuditScheduleAuditSchedulesGet";

export function getAuditScheduleAuditSchedulesGetUrl(scheduleId: AuditScheduleAuditSchedulesGetPathParams["scheduleId"]) {
  const res = { method: 'GET', url: `/audit-schedule/v1/schedules/${scheduleId}` as const }
  return res
}

/**
 * @description Returns a schedule with its linked `audio` and `matches` included by default.
 * @summary Get schedule
 * {@link /audit-schedule/v1/schedules/:scheduleId}
 */
export async function auditScheduleAuditSchedulesGet(scheduleId: AuditScheduleAuditSchedulesGetPathParams["scheduleId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditScheduleAuditSchedulesGetQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAuditScheduleAuditSchedulesGetUrl(scheduleId).url.toString(), ... requestConfig })
  return res.data
}